(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["miramar-gift-wrap"]) return;
  try {
    
  if (!customElements.get('miramar-gift-wrap')) {
    customElements.define('miramar-gift-wrap', class extends HTMLElement {
      connectedCallback() {
        this.free = this.querySelector('[data-free-box]');
        this.quantity = this.querySelector('[data-extra-quantity]');
        this.extra = this.querySelector('[data-extra-boxes]');
        this.status = this.querySelector('[data-gift-status]');
        this.savedQuantity = Number(this.quantity.value);
        this.savedFree = this.free.checked;
        if (typeof subscribe === 'function') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, async event => {
            if (event.source !== 'cart-items') return;
            const items = event.cartData?.items || [];
            if (items.every(item => String(item.variant_id) === this.dataset.variantId)) {
              this.setPending(true);
              try {
                const response = await fetch(this.dataset.root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: { [this.dataset.variantId]: 0 }, attributes: { 'Caja de regalo gratuita': 'No' } }) });
                if (!response.ok) throw new Error();
              } catch { this.status.textContent = this.dataset.error; return; }
            }
            window.location.reload();
          });
        }
        this.free.addEventListener('change', () => {
          this.extra.hidden = !this.free.checked;
          if (!this.free.checked) this.quantity.value = 0;
          this.save();
        });
        this.quantity.addEventListener('input', () => this.setPending(true));
        this.quantity.addEventListener('change', () => this.save());
        this.querySelector('[data-save-boxes]').addEventListener('click', () => this.save());
        this.guard = (event) => {
          if (this.busy || Number(this.quantity.value) !== this.savedQuantity || this.free.checked !== this.savedFree) {
            event.preventDefault();
            event.stopImmediatePropagation();
            if (!this.busy) this.save();
          }
        };
        document.getElementById('cart')?.addEventListener('submit', this.guard, true);
      }
      disconnectedCallback() { document.getElementById('cart')?.removeEventListener('submit', this.guard, true); this.unsubscribe?.(); }
      setPending(pending) {
        document.documentElement.classList.toggle('miramar-gift-pending', pending);
        const checkout = document.getElementById('checkout');
        if (checkout) checkout.disabled = pending;
        document.querySelectorAll('.cart__dynamic-checkout-buttons').forEach(el => el.inert = pending);
      }
      async save() {
        if (this.busy) return;
        if (!this.quantity.checkValidity()) { this.quantity.reportValidity(); return; }
        const quantity = this.free.checked ? Number(this.quantity.value) : 0;
        if (!Number.isSafeInteger(quantity) || quantity < 0) return;
        this.busy = true;
        this.setPending(true);
        this.status.textContent = this.dataset.saving;
        this.querySelectorAll('input, button').forEach(el => el.disabled = true);
        try {
          const cartResponse = await fetch(this.dataset.root + 'cart.js', { headers: { Accept: 'application/json' } });
          if (!cartResponse.ok) throw new Error();
          const cart = await cartResponse.json();
          if (!cart.items.some(item => String(item.variant_id) !== this.dataset.variantId)) throw new Error();
          const response = await fetch(this.dataset.root + 'cart/update.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates: { [this.dataset.variantId]: quantity }, attributes: { 'Caja de regalo gratuita': this.free.checked ? 'Sí' : 'No' } })
          });
          const result = await response.json();
          if (!response.ok || result.errors || result.status) throw new Error();
          window.location.reload();
        } catch {
          this.busy = false;
          this.status.textContent = this.dataset.error;
          this.querySelectorAll('input, button').forEach(el => el.disabled = false);
          this.setPending(true);
          const checkout = document.getElementById('checkout');
          if (checkout) checkout.disabled = true;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
